import { CreateWorker } from "@pdfking/storage"

import { WorkerForward } from "../recipies/WorkerForward"
import { RoundRobin } from "../routing/RoundRobin"
import type { MessageRouter } from "../types/MessageRouter"

export function WorkerPool<T, R>(
  path: URL,
  size: number = 1,
  forward?: MessageRouter<T, R>
): MessageRouter<T, R> {
  const dispatch: MessageRouter<T, R> = request => outgoing(request)
  const workers = Array.from({ length: size }, () =>
    WorkerForward<T, R>(CreateWorker(path), dispatch)
  )
  const router = RoundRobin(workers)
  const outgoing = forward ?? router
  return router
}
